import axios, { AxiosRequestConfig } from "axios";

import getErrorDetails from "../../../api/helpers/getErrorDetails";

export type PostTwoFactorGenerate = (
  options?: AxiosRequestConfig
) => Promise<SVGAElement>;

export const postTwoFactorGenerate: PostTwoFactorGenerate = async (options) => {
  try {
    const response = await axios.post<SVGAElement>(
      "/users/settings/2fa/generate.svg",
      undefined,
      options
    );

    return response.data;
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export type PostTwoFactorEnable = (
  code: string,
  options?: AxiosRequestConfig
) => Promise<null>;

export const postEnableCurrentUser2FA: PostTwoFactorEnable = async (
  code,
  options
) => {
  try {
    const response = await axios.post<null>(
      "/users/settings/2fa/enable",
      { code },
      options
    );

    return response.data;
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export interface DisableCurrentUser2FAParams {
  code: string;
}

export type PostTwoFactorDisable = (
  data: DisableCurrentUser2FAParams,
  options: AxiosRequestConfig
) => Promise<void>;

export const postDisableCurrentUser2FA: PostTwoFactorDisable = async (
  data,
  options
) => {
  try {
    await axios({
      ...options,
      method: "POST",
      url: "/users/settings/2fa/disable",
      data,
    });
  } catch (error) {
    throw getErrorDetails(error);
  }
};
